const translations = {
  page_title: 'Deals',
  header_title: 'New deal',

  vehicle: 'Vehicle',
  buyer: 'Buyer',
  deal: 'Deal',

  select_from_leads: 'Select from leads',
  select_lead: 'Select lead',

  type: 'Type',
  type_placeholder: 'Type',
  invalid_type: 'Invalid type',

  pronto: 'Pronto',
  pronto_placeholder: 'Enter pronto',
  pronto_payment_type: 'Pronto payment type',
  pronto_payment_type_placeholder: 'Select Pronto payment type',
  sales_manager: 'Sales manager',
  sales_manager_placeholder: 'Select sales manager',
  finance_manager: 'Finance manager',
  finance_manager_placeholder: 'Select finance manager',
  salesman_1: 'Salesman 1',
  salesman_1_placeholder: 'Select salesman 1',
  salesman_2: 'Salesman 2',
  salesman_2_placeholder: 'Select salesman 2',

  invalid_value: 'Invalid value',

  financiamiento: 'Financiamiento',
  institucion: 'Institución',
  institucion_placeholder: 'Select institucion',
  termino: 'Término',
  termino_placeholder: 'Enter payments',
  monto_a_financiar: 'Monto a financiar',
  monto_a_financiar_placeholder: 'Monto a financiar',
  apr: 'APR',
  apr_placeholder: 'APR',

  sale_price: 'Sale price',

  start_deal: 'Start deal',
  view_details: 'View details',

  deal_created: 'Deal created successfully',
};

export default translations;
